<template>
	<div class="date-range-control row">
		<div class="col-md-6 pt-0">
			<input type="date" :value="dateString" class="form-control" @change="onChange" ref="date" />
		</div>
		<div class="col-md-3 pt-0">
			<input
				type="number"
				class="form-control"
				placeholder="Hour"
				min="0"
				max="23"
				:value="hourString"
				@change="onChange"
				ref="hour"
			/>
		</div>
		<div class="col-md-3 pt-0">
			<input
				type="number"
				class="form-control"
				placeholder="Minute"
				min="0"
				max="59"
				:value="minuteString"
				@change="onChange"
				ref="minute"
			/>
		</div>
	</div>
</template>

<script>
import moment from 'moment';

export default {
	props: {
		value: {
			type: String,
			default: '',
		},
	},
	computed: {
		dateString() {
			const m = moment(this.value);
			if (!m.isValid()) {
				return '';
			} else {
				return m.format('YYYY-MM-DD');
			}
		},
		hourString() {
			const m = moment(this.value);
			if (!m.isValid()) {
				return '';
			} else {
				return m.format('HH');
			}
		},
		minuteString() {
			const m = moment(this.value);
			if (!m.isValid()) {
				return '';
			} else {
				return m.format('mm');
			}
		},
	},
	data() {
		return {
			date: null,
		};
	},
	methods: {
		getDate() {
			const m = moment(this.value);
			if (!m.isValid()) {
				return '';
			} else {
				return m.format('YYYY-MM-DD');
			}
		},
		onChange() {
			const date = this.$refs.date.value;
			const hour = parseInt(this.$refs.hour.value);
			const minute = parseInt(this.$refs.minute.value);
			let dateString = '';
			if (date) {
				const m = moment(date);
				m.set({ hour, minute, second: 0, millisecond: 0 });
				dateString = m.toJSON();
            }
			this.$emit('input', dateString);
		},
	},
};
</script>

<style lang="scss" scoped></style>
